import {css, Global} from "@emotion/react/macro";
import styled from "@emotion/styled/macro";
import {PropsWithChildren, useEffect, useState} from "react";
import { useCommunityContext } from "../../context/communityContext";


const ThemeColorsDiv = styled.div`

    --gold: #eba900;
  --on2blue: #185a7d;
  --terracotta: #d7592a;
  --darksteel: #003349;
  
  
`

export const ThemeColors = {
    gold: "#eba900",
    on2blue: "#185a7d",
    terracotta: "#d7592a",
    darksteel: "#003349",
    darkplatinum: "#565755",
    lightplatinum: "#F3F4F2",
    platinum: "#D8D9D4",
    success: "#34A853"



}
const LayoutDiv = styled.div`
  height: 100%;
  width: 100%;
`

const GlobalLayout: React.FC<PropsWithChildren> = (props) => {


    return <LayoutDiv>
        <Global styles={css`
          html, body {
            width: 100%;
            height: 100%;
          }

          #root {
            width: 100%;
            height: 100%;
          
          }
`}/>

        {props.children}
    </LayoutDiv>
}

export default GlobalLayout;